import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useTranslations } from "use-intl";
import { useAuth } from "../auth";
import { authClient } from "../lib/auth-client";
import { Brand } from "./Brand";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { LoginShowreel } from "./LoginShowreel";
import { trackFlowTraceSelf } from "./PublicFlowTraceAnalytics";

export const LoginPage = () => {
  const t = useTranslations("auth");
  const { signOut, status, user } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  if (status === "authorized") return <Navigate replace to="/" />;

  const signIn = async () => {
    setSubmitting(true);
    setError(false);
    trackFlowTraceSelf("auth.google.started");
    try {
      const result = await authClient.signIn.social({
        callbackURL: "/",
        errorCallbackURL: "/login?error=google",
        provider: "google",
      });
      if (result.error) {
        trackFlowTraceSelf("auth.google.failed");
        setError(true);
      }
    } catch {
      trackFlowTraceSelf("auth.google.failed");
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LoginShowreel
      header={(
        <header className="login-topbar">
          <Brand />
          <LanguageSwitcher />
        </header>
      )}
    >
      <main className="login-card">
        <div className="login-mark" aria-hidden="true">↗</div>
        <p className="eyebrow">{t("eyebrow")}</p>
        <h1>{t("title")}</h1>
        <p>{t("description")}</p>

        {status === "loading" && <div className="auth-status">{t("loading")}</div>}
        {status === "not-configured" && (
          <div className="auth-status auth-status-error">{t("notConfigured")}</div>
        )}
        {status === "forbidden" && (
          <div className="auth-status auth-status-error">
            <strong>{t("forbiddenTitle")}</strong>
            <span>{t("forbiddenDescription", { email: user?.email ?? "" })}</span>
            <button className="text-link auth-switch-account" onClick={() => void signOut()} type="button">
              {t("switchAccount")}
            </button>
          </div>
        )}
        {status === "signed-out" && (
          <button
            className="google-sign-in"
            data-flowtrace-id="auth.google"
            disabled={submitting}
            onClick={() => void signIn()}
            type="button"
          >
            <span aria-hidden="true">G</span>
            {submitting ? t("redirecting") : t("signInGoogle")}
          </button>
        )}
        {error && <p className="login-error">{t("signInError")}</p>}
        <small>{t("allowlistNotice")}</small>
      </main>
    </LoginShowreel>
  );
};
